import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultBanner = ({
  button,
  titleText,
  subtext,
  dataTestId,
  marginStyle,
  icon
}) => {
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "row",
    paddingBlock: "400",
    paddingInline: "500",
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderRadius: "transitional-component",
    borderStyle: "solid",
    role: "alert",
    "data-nudge-type": "ALERT_INLINE",
    "data-test-id": dataTestId,
    inlineSize: "100%"
  }, marginStyle, {
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexDirection: "row",
      flexShrink: 0,
      children: icon
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "300",
      children: [/*#__PURE__*/_jsx(H5, {
        marginBlockEnd: "0",
        marginInlineEnd: "0",
        display: "inline",
        children: titleText
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          children: subtext
        }), button]
      })]
    })]
  }));
};
export default DefaultBanner;